var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[("" + _vm.cssPrefix),
  ( _obj = {}, _obj[(_vm.cssPrefix + "--vertical")] = _vm.forVertical, _obj[(_vm.cssPrefix + "--horizontal")] = !_vm.forVertical, _obj )],style:({zIndex: _vm.zIndex})},[_c('div',{class:[(_vm.cssPrefix + "__track"), (_vm.cssPrefix + "__track--" + _vm.theme)]},[_c('div',{class:[(_vm.cssPrefix + "__track__thumb")],style:(_vm.thumbStyle),on:{"mousedown":_vm.onDragThumb}})])])}
var staticRenderFns = []

export { render, staticRenderFns }